import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkbox__wrapper" }
const _hoisted_2 = { class: "checkbox__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("input", {
      class: "checkbox__input",
      type: "checkbox"
    }, null, -1)),
    _createElementVNode("label", {
      ref: "width",
      class: _normalizeClass(["checkbox__label", {
        'checkbox__label--checked': _ctx.input,
      }])
    }, [
      _createElementVNode("div", {
        class: "checkbox__border",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.input = !_ctx.input), ["prevent"]))
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "checkbox__border-inner" }, null, -1),
        _createElementVNode("div", { class: "checkbox__image" }, null, -1)
      ])),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.text), 1),
        _renderSlot(_ctx.$slots, "link", {}, undefined, true),
        _createElementVNode("span", null, _toDisplayString(_ctx.text2), 1),
        _renderSlot(_ctx.$slots, "link2", {}, undefined, true)
      ])
    ], 2)
  ]))
}